import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { apiGetUserRedirectInformation } from '../../api/universal';
import JoveLogoLoading from '../../mui/loading/logoLoading';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveRouteJumpView = function JoveRouteJumpView(props) {
  var className = props.className,
      urlParams = props.urlParams;
  /**
   * requests
   */

  var requestRouteJumpInformation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _res$data;

      var _yield$apiGetUserRedi, _yield$apiGetUserRedi2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apiGetUserRedirectInformation(urlParams);

            case 2:
              _yield$apiGetUserRedi = _context.sent;
              _yield$apiGetUserRedi2 = _slicedToArray(_yield$apiGetUserRedi, 1);
              res = _yield$apiGetUserRedi2[0];

              if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.redirect_url) {
                window.location.href = res.data.redirect_url;
              } else {
                setTimeout(function () {
                  requestRouteJumpInformation();
                }, 2000);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestRouteJumpInformation() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    if (urlParams) {
      requestRouteJumpInformation();
    }
  }, [urlParams]);
  return /*#__PURE__*/_jsx(Box, {
    className: clsx('relative flex flex-col', className),
    children: /*#__PURE__*/_jsx(JoveLogoLoading, {
      label: "The page is still processing and you are being redirected. Please wait a moment."
    })
  });
};

export default JoveRouteJumpView;